"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _spinner = require("@design/ui/spinner");
var _PageContext = require("../context/PageContext");
var _AuthContext = require("../context/AuthContext");
var _toast = require("../utils/toast");
var _networkDiagnostics = require("../utils/networkDiagnostics");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var STATUS_ICONS = {
  pending: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CircleIcon, {
    width: 18,
    height: 18,
    className: "text-gray-300"
  }),
  running: /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
    className: "size-4.5 text-muted-foreground"
  }),
  pass: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {
    width: 18,
    height: 18,
    className: "text-green-600"
  }),
  warn: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
    width: 18,
    height: 18,
    className: "text-amber-500"
  }),
  fail: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CancelIcon, {
    width: 18,
    height: 18,
    className: "text-red-600"
  })
};
var CheckRow = function CheckRow(_ref) {
  var result = _ref.result;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex gap-2.5 items-start border border-gray-100 rounded-md p-3",
    "data-sentry-component": "CheckRow",
    "data-sentry-source-file": "NetworkDiagnosticsPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "shrink-0 mt-0.5",
      children: STATUS_ICONS[result.status]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-1 min-w-0 flex flex-col gap-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-sm font-semibold text-[#3D3D3D]",
        children: result.label
      }), result.detail && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-[#6B7280] break-words",
        children: result.detail
      }), result.guidance && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-[#3D3D3D] bg-amber-50 border border-amber-100 rounded p-2 break-words",
        children: result.guidance
      }), result.evidence && /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", {
        className: "text-xs",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("summary", {
          className: "cursor-pointer text-[#6B7280] select-none",
          children: "Technical details"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dl", {
          className: "mt-1 m-0 flex flex-col gap-0.5 font-mono text-[11px] leading-snug text-[#6B7280]",
          children: Object.entries(result.evidence).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "break-words",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("dt", {
                className: "inline text-[#3D3D3D]",
                children: [key, ": "]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dd", {
                className: "inline m-0",
                children: value
              })]
            }, key);
          })
        })]
      })]
    })]
  });
};
var NetworkDiagnosticsPage = function NetworkDiagnosticsPage() {
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    results = _useState2[0],
    setResults = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRunning = _useState4[0],
    setIsRunning = _useState4[1];
  var handleRun = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (authHeader) {
            _context.n = 1;
            break;
          }
          (0, _toast.toastError)("You need to be signed in to run network diagnostics.");
          return _context.a(2);
        case 1:
          setIsRunning(true);
          _context.p = 2;
          _context.n = 3;
          return (0, _networkDiagnostics.runNetworkDiagnostics)(authHeader, setResults);
        case 3:
          _context.p = 3;
          setIsRunning(false);
          return _context.f(3);
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[2,, 3, 4]]);
  })), [authHeader]);
  var handleCopy = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return navigator.clipboard.writeText((0, _networkDiagnostics.formatDiagnosticsReport)(results));
        case 1:
          (0, _toast.toastSuccess)("Report copied to clipboard");
          _context2.n = 3;
          break;
        case 2:
          _context2.p = 2;
          _t = _context2.v;
          (0, _toast.toastError)("Couldn't copy the report. Select the results and copy them manually.");
        case 3:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 2]]);
  })), [results]);
  var hasFinished = results.length > 0 && !isRunning;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "w-full h-full bg-white flex flex-col gap-4 p-4",
    "data-sentry-component": "NetworkDiagnosticsPage",
    "data-sentry-source-file": "NetworkDiagnosticsPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex gap-2 items-center sticky top-0 w-full",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: function onClick() {
          return showPage(_PageContext.PAGES.chatPage);
        },
        className: "block cursor-pointer overflow-clip relative shrink-0 size-6 border-none bg-transparent p-0",
        "aria-label": "Go back",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {
          width: 24,
          height: 24,
          fill: "#171715",
          "data-sentry-element": "ChevronLeftIcon",
          "data-sentry-source-file": "NetworkDiagnosticsPage.tsx"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "flex-1 font-semibold text-[20px] leading-[1.4] text-[#3D3D3D] m-0",
        children: "Network diagnostics"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-xs text-[#6B7280] m-0",
      children: "Checks whether this computer can reach Dioptra and exchange live responses. If your network blocks or alters our traffic, the failing check below explains what your IT team needs to change."
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex gap-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleRun,
        disabled: isRunning,
        className: "flex-1 h-10 rounded-md bg-primary text-white text-sm font-semibold cursor-pointer border-none disabled:opacity-50 disabled:cursor-not-allowed",
        children: isRunning ? "Running diagnostics..." : "Run diagnostics"
      }), hasFinished && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleCopy,
        className: "h-10 px-4 rounded-md bg-white text-[#3D3D3D] text-sm font-semibold cursor-pointer border border-gray-200 hover:bg-gray-50",
        children: "Copy report"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1 overflow-y-auto overflow-x-hidden flex flex-col gap-2",
      children: results.map(function (result) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckRow, {
          result: result
        }, result.id);
      })
    })]
  });
};
var _default = exports.default = NetworkDiagnosticsPage;